import { Component, OnInit, viewChild, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { PayoutLineItemType } from '../../../../../shared/enums/payout-line-item-type';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-payout-adjustment-dialog',
  standalone: true,
  imports: [FormsModule, ButtonComponent, InputTextModule, AutoCompleteModule, InputNumberModule],
  templateUrl: './payout-adjustment-dialog.component.html',
  styleUrl: './payout-adjustment-dialog.component.scss',
})
export class PayoutAdjustmentDialogComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  readonly payoutForm = viewChild.required<NgForm>('payoutForm');
  loading = false;
  reason: string = '';
  suggestions: string[] = [];
  filteredSuggestions: string[] = [];

  ngOnInit() {
    this.filteredSuggestions = [...this.suggestions];
  }

  confirmAction() {
    const payoutForm = this.payoutForm();
    if (payoutForm.invalid) return;

    this.loading = true;
    const body = {
      amount: payoutForm.value.payoutAdjustment,
      internalNote: payoutForm.value.reason,
      typeId: PayoutLineItemType.Adjustment,
    };
    this.requestBuilder.post(`rides/${this.config.data.uuid}/payout-adjustment`, body).subscribe({
      next: () => {
        this.loading = false;
        this.ref.close({ confirmed: true });
      },
      error: error => {
        this.loading = false;
      },
    });
  }

  filterSuggestions(event: any, autoComplete: AutoComplete) {
    if (this.reason) {
      this.filteredSuggestions = this.suggestions.filter(suggestion => suggestion.toLowerCase().includes(this.reason.toLowerCase()));
    } else {
      this.filteredSuggestions = [...this.suggestions];
      if (this.filteredSuggestions.length > 0) {
        autoComplete.show();
      }
    }
  }
}
